import _ from 'lodash';
import axios from 'axios';

import { ALERT_SUCCESS, ALERT_ERROR, ALERT_CLOSE } from '../constants/alertTypes';

export const alertSuccess = (message, uppercase = true) => ({ type: ALERT_SUCCESS, payload: { message, uppercase } });

export const alertError =
  (error, uppercase = true) =>
  (dispatch) => {
    if (error instanceof axios.Cancel) return;

    let message = 'Something went wrong - please try again in a few minutes';
    const response = error.response;

    if (!response && error.message) {
      message = error.message;
    } else if (response && response.data) {
      if (response.status === 401) {
        return;
      }

      if (_.isArray(response.data.message)) {
        message = response.data.message.join('\n');
      } else if (response.data.message !== '') {
        message = response.data.message;
      }
    } else if (typeof error === 'string') {
      message = error;
    }

    return dispatch({ type: ALERT_ERROR, payload: { message, uppercase } });
  };

export const alertClose = (index) => ({ type: ALERT_CLOSE, payload: index });
